<template>
  <div>
    <b-list-group>
      <b-list-group-item
        button
        class="py-2"
        variant="warning"
        @click="createNew"
        ><b-icon-plus class="mr-2"></b-icon-plus>Neuer
        Eintrag</b-list-group-item
      >
      <Recipe
        v-for="item in recipes"
        :item="item"
        :key="item.id"
        :showEdit="true"
        :showDetails="true"
        @edit="edit(item)"
      />
      <infinite-loading
        @infinite="infiniteHandler"
        v-if="!loading"
        :identifier="loaderResetter"
      >
        <div slot="no-more" class="text-muted py-1">
          <small>Keine weiteren Einträge.</small>
        </div>
        <div slot="no-results" class="text-muted py-1">
          <small>Keine Einträge gefunden.</small>
        </div>
      </infinite-loading>
    </b-list-group>
  </div>
</template>

<script>
// TODO Filter für die Rezepte

import { mapState, mapGetters } from "vuex";
import axios from "axios";
import Recipe from "@/components/Recipe.vue";
import { Recipe as RecipeClass, Types } from "@/class/recipe";
import InfiniteLoading from "vue-infinite-loading";
import { getRecipe } from "../class/recipe";

export default {
  name: "Recipes",
  components: {
    Recipe,
    InfiniteLoading
  },
  beforeMount() {
    this.resetRecipe();
  },
  data() {
    return {
      loaderResetter: new Date(),
      types: Types,
      typeFilter: [],
      modalEditShow: false,
      currentRecipe: null,
      page: 0,
      recipes: []
    };
  },
  computed: {
    availableTypes() {
      return this.types.filter(opt => this.typeFilter.indexOf(opt) === -1);
    },
    ...mapGetters(["getItemVariantColor"]),
    ...mapState({
      // arrow functions can make the code very succinct!
      loading: state => state.loading
    })
  },
  watch: {
    typeFilter() {
      this.maxLen = 0;
      this.page = 0;
      this.loaderResetter = new Date();
    }
  },
  methods: {
    resetRecipe() {
      this.currentRecipe = new RecipeClass("");
    },
    createNew() {
      this.$store.commit(
        "SET_DETAILITEM",
        JSON.parse(JSON.stringify(new RecipeClass("")))
      );
      this.$store.commit("SHOW_EDITMODAL", true);
    },
    edit(item) {
      getRecipe(item.id).then(recipe => {
        this.$store.commit("SET_DETAILITEM", recipe);
        this.$store.commit("SHOW_EDITMODAL", true);
      });
    },
    infiniteHandler($state) {
      this.page++;
      axios
        .post(process.env.VUE_APP_API_URL + "?recipe", {
          cmd: "get",
          limit: 15,
          offset: (this.page - 1) * 15
        })
        .then(r => {
          if (r.data.length > 0) {
            this.recipes.push(...r.data);
            $state.loaded();
          } else {
            $state.complete();
          }
        });
    }
  }
};
</script>

<style></style>
